import type { QueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import i18n from '../i18n';
import { putWithCSRF } from './axiosWithCSRF';
import { envApiUrl } from './envApiUrl';

interface MydayType {
  id: number;
}

export const handleUpdateMyday = async (data: any, myday: MydayType, queryClient?: QueryClient, onOk?: () => void) => {
  console.log('handleUpdateMyday data', data, myday);
  if (!myday.id) return;

  try {
    const response = await putWithCSRF(envApiUrl + '/mydays', data, {
      headers: {
        id: myday.id,
      },
    });
    console.log('Update Myday: response: ', response);

    // Invalidate mydays query to refresh the list
    if (queryClient) {
      queryClient.invalidateQueries({ queryKey: ['useMydays'] });
    }

    onOk?.();
    return response.data;
  } catch (err: any) {
    console.error('handleUpdateMyday error: ', err.response?.data?.message, err);
    message.error(err.response?.data?.message || i18n.t('myday.mydayUpdateFailed'));
  }
};
